/* Theme-owned enhancements: native Liquid remains the initial storefront. */
(() => {
  document.addEventListener('scroll', event => {
    const frames = event.target;
    if (!(frames instanceof HTMLElement) || !frames.matches('.k15-card-frames')) return;
    const media = frames.closest('.product-card__media');
    media.dataset.k15Slide = String(Math.round(frames.scrollLeft / Math.max(1, frames.clientWidth)));
  }, true);
  document.addEventListener('keydown',event=>{
    const gallery=event.target.closest?.('.k15-card-frames');
    if(!gallery||event.altKey||event.ctrlKey||event.metaKey||!['ArrowLeft','ArrowRight'].includes(event.key))return;
    event.preventDefault();gallery.scrollBy({left:(event.key==='ArrowRight'?1:-1)*gallery.clientWidth,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
  });
  let pointer;
  document.addEventListener('pointerdown', event => {
    const frames = event.target.closest?.('.k15-card-frames');
    pointer = frames ? {frames, x:event.clientX, y:event.clientY} : null;
  }, {passive:true});
  document.addEventListener('click', event => {
    if (pointer && pointer.frames.contains(event.target) && (Math.abs(event.clientX-pointer.x)>10 || Math.abs(event.clientY-pointer.y)>10)) event.preventDefault();
    pointer = null;
  }, true);
  const topMenus = nav => [...nav.querySelectorAll(':scope > .k15-nav-group > details')];
  const closeMenu = menu => {menu.open=false;menu.querySelectorAll('details[open]').forEach(child=>child.open=false);};
  const closeMenus = (nav, except) => topMenus(nav).forEach(menu=>{if(menu!==except)closeMenu(menu);});
  const fitMenu = menu => {
    const nav=menu.closest('.desktop-nav'),panel=menu.querySelector(':scope > .k15-mega');
    if(!nav||!panel)return;
    const links=panel.querySelectorAll('a:not([hidden])').length;
    panel.dataset.menuSize=links>20?'large':links>6?'medium':'small';
    const rect=nav.getBoundingClientRect(),trigger=menu.querySelector(':scope > summary').getBoundingClientRect();
    panel.style.setProperty('--menu-space',Math.max(100,innerHeight-rect.bottom-16)+'px');
    requestAnimationFrame(()=>{
      const width=panel.getBoundingClientRect().width;
      panel.style.left=Math.max(0,Math.min(trigger.left-rect.left,rect.width-width))+'px';
    });
  };
  document.addEventListener('click',event=>{
    const summary=event.target.closest('.k15-nav-disclosure > summary');
    const nav=summary?.closest('.desktop-nav, .mobile-nav');
    if(nav){const menu=summary.parentElement;closeMenus(nav,menu);fitMenu(menu);if(nav.matches('.mobile-nav'))requestAnimationFrame(()=>summary.scrollIntoView({block:'nearest'}));}
    const nested=event.target.closest('.k-nav-submenu-trigger');
    if(nested){const parent=nested.closest('.k15-mega');parent.querySelectorAll('.k26-nav-group[open]').forEach(group=>{if(group!==nested.parentElement)group.open=false;});}
    for(const desktop of document.querySelectorAll('.desktop-nav'))if(!desktop.contains(event.target))closeMenus(desktop);
  });
  document.addEventListener('focusin',event=>{for(const nav of document.querySelectorAll('.desktop-nav'))for(const menu of topMenus(nav))if(menu.open&&!menu.contains(event.target))closeMenu(menu);});
  document.addEventListener('keydown',event=>{
    const nav=event.target.closest('.desktop-nav, .mobile-nav');if(!nav)return;
    if(event.key==='Escape'){
      const nested=event.target.closest('.k26-nav-group[open]');
      const menu=nested||topMenus(nav).find(item=>item.open);
      if(menu){event.preventDefault();event.stopPropagation();closeMenu(menu);menu.querySelector(':scope > summary').focus();}
    }
    if(event.key==='ArrowDown'&&event.target.matches('.desktop-nav .k15-nav-disclosure > summary')){
      event.preventDefault();const menu=event.target.parentElement;closeMenus(nav,menu);menu.open=true;fitMenu(menu);menu.querySelector('.k15-mega a:not([hidden])')?.focus();
    }
  });
  window.addEventListener('resize',()=>{
    for(const nav of document.querySelectorAll('.desktop-nav, .mobile-nav')){
      if(!nav.getClientRects().length)closeMenus(nav);else topMenus(nav).filter(menu=>menu.open).forEach(fitMenu);
    }
    if(innerWidth>=1100){const drawer=document.querySelector('#KukurMenu[open]');drawer?.querySelector('[data-close-dialog]')?.click();}
  });
  // Preserve Shopify order for manual collections and every explicit native sort.
  const normalizeType = product => {
    const type = product.type.toLocaleLowerCase('lt');
    const handle = product.handle;
    if (handle.includes('su-uztrauktuku')) return 'Su užtrauktuku';
    if (type.includes('vaikišk') || type==='kids clothes') return 'Vaikams';
    if (type.includes('kūdiki') || type.includes('smėlinuk') || handle.includes('smelinuk')) return 'Smėlinukas';
    if (type.includes('marškin') || type==='t-shirt') return 'Marškinėliai';
    if (type.includes('džemper') || ['hoodie','sweatshirt'].includes(type)) return 'Džemperiai';
    if (['puodeliai','puodelis','mug'].includes(type)) return 'Puodeliai';
    if (type.includes('kepur')) return 'Kepurės';
    if (type.includes('kojin')) return 'Kojinės';
    if (type.includes('prijuost')) return 'Prijuostės';
    if (type.includes('krepš') || type==='bags') return 'Krepšiai';
    return product.type;
  };
  class KukurGiftFilters extends HTMLElement {
    static matchesType(item,type) {
      const normalized=normalizeType(item);
      const house=['Puodelis','Prijuostė','Pelės kilimėlis','Pledas','Plakatas','Drobės paveikslas','Dekoratyvinė pagalvėlė','Kvapioji žvakė','Sieninis laikrodis','Stiklinė','Pjaustymo lentelė'];
      const work=['Užrašinė','Darbo kalendorius','Pelės kilimėlis','Didelis stalo kilimėlis','Nešiojamojo kompiuterio dėklas'];
      return !type || item.type===type || normalized===type || (type==='Vaikams'&&normalized==='Smėlinukas') || (type==='Aksesuarai'&&['Krepšys','Bags','Kojinės','Prijuostė','Apron','Kepurė'].includes(item.type)) || (type==='Namams'&&house.includes(item.type)) || (type==='Darbui'&&work.includes(item.type));
    }
    async prepare() {
      if(this.items){this.populateExtraFilters();return;}
      this.setAttribute('aria-busy','true');
      this.loading.textContent=this.messages.loading;
      try { await this.catalogue(); if(this.isConnected){this.populateExtraFilters();this.loading.textContent='';if(!this.filtered)await this.apply(false);} }
      catch(error) { if(error.name!=='AbortError')this.loading.textContent=this.messages.error; }
      finally { this.removeAttribute('aria-busy'); }
    }
    connectedCallback() {
      if (this.controller) return;
      this.controller=new AbortController();
      this.fields=[...this.querySelectorAll('select')];
      this.grid=document.querySelector('.collection-section .catalog-results .product-grid');
      this.results=document.querySelector('.collection-section [data-k15-results]');
      this.status=this.results.querySelector('[data-k15-status]');
      this.count=document.querySelector('.collection-count');
      this.initialCount=this.count?.textContent;
      this.messages=JSON.parse(this.querySelector('[data-k15-messages]').textContent);
      this.loading=this.querySelector('[data-k15-loading]');
      this.more=this.results.querySelector('[data-k15-more]');
      const params=new URL(location.href).searchParams;
      if(params.get('k15_type')==='Kūdikiams')params.set('k15_type','Smėlinukas');
      this.recipientOptions=[...this.fields[1].options].filter(option=>option.value).map(option=>({value:option.value,label:option.textContent}));
      this.fields.forEach(field=>{field.dataset.selected=params.get(field.name)||field.value;field.value=field.dataset.selected;});
      this.fields.forEach(field=>field.addEventListener('change',()=>this.apply(),{signal:this.controller.signal}));
      this.more.addEventListener('click',()=>{const previous=this.limit;this.limit+=24;this.render();this.grid.children[previous]?.querySelector('a')?.focus();},{signal:this.controller.signal});
      this.querySelector('[data-k15-clear]').addEventListener('click',()=>{this.fields.forEach(field=>field.value='');this.apply();},{signal:this.controller.signal});
      this.querySelectorAll('[data-k15-quick]').forEach(link=>link.addEventListener('click',event=>{
        event.preventDefault();this.fields.forEach(field=>field.value='');
        const field=link.dataset.k15Field==='type'?this.fields[0]:this.fields[1];
        field.value=link.dataset.k15Value;this.apply();
      },{signal:this.controller.signal}));
      if(this.fields.some(field=>params.has(field.name))) this.apply(false);
      this.addEventListener('focusin',()=>this.prepare(),{signal:this.controller.signal});
      this.addEventListener('pointerenter',()=>this.prepare(),{signal:this.controller.signal});
      window.addEventListener('popstate',()=>this.apply(false),{signal:this.controller.signal});this.prepare();
    }
    disconnectedCallback(){this.controller?.abort();this.controller=null;this.pending=null;}
    async catalogue() {
      if(this.items) return this.items;
      if(this.pending) return this.pending;
      const signal=this.controller.signal;
      const pending=this.pending=(async()=>{
        const getPage=async(page)=>{
          const url=new URL(location.href);for(const field of this.fields)url.searchParams.delete(field.name);url.searchParams.set('view','k15-data');url.searchParams.set('page',page);
          for(let attempt=0;attempt<3;attempt++){
            const response=await fetch(url,{signal,credentials:'same-origin'});
            if(response.ok)return response.json();
            if(response.status!==429&&response.status<500)throw Error('Catalogue unavailable');
            await new Promise(resolve=>setTimeout(resolve,500*(attempt+1)));
          }
          throw Error('Catalogue unavailable');
        };
        const first=await getPage(1),items=[...first.products];
        for(let page=2;page<=first.pages;page+=4){
          const batch=await Promise.all(Array.from({length:Math.min(4,first.pages-page+1)},(_,offset)=>getPage(page+offset)));
          for(const result of batch)items.push(...result.products);
        }
        this.items=items;return items;
      })();
      try{return await pending;}finally{if(this.pending===pending)this.pending=null;}
    }
    populateExtraFilters(){
      if(!this.items||this.hasAttribute('data-k15-ready'))return;
      const populate=(field,values)=>{
        const selected=field.dataset.selected||field.value;
        while(field.options.length>1)field.remove(1);
        for(const {value,label,count} of values){const option=document.createElement('option');option.value=value;option.textContent=label+' ('+count+')';field.append(option);}
        field.value=selected;field.disabled=!values.length;field.closest('label').hidden=field.disabled;
      };
      const types=new Map();for(const item of this.items)if(item.type)types.set(item.type,(types.get(item.type)||0)+1);
      populate(this.fields[0],[...types].sort(([a],[b])=>a.localeCompare(b,'lt')).map(([value,count])=>({value,label:value,count})));
      populate(this.fields[1],this.recipientOptions.map(({value,label})=>({value,label,count:this.items.filter(item=>KukurGiftFilters.matchesRecipient(item,value)).length})).filter(option=>option.count>0));
      for(const field of this.fields.slice(2)){
        const prefix=field.name==='k17_occasion'?/^(proga[-:]|occasion:)/:field.name==='k17_style'?/^(stilius:|style:)/:/^(pomegis[-:]|pomėgis:|profesija[-:]|tema[-:])/;
        const counts=new Map();for(const item of this.items)for(const tag of new Set(item.tags))if(prefix.test(tag))counts.set(tag,(counts.get(tag)||0)+1);
        populate(field,[...counts].sort(([a],[b])=>a.localeCompare(b,'lt')).map(([value,count])=>({value,label:value.replace(prefix,'').replaceAll('-',' '),count})));
      }
      this.toggleAttribute('data-k15-ready',true);
      const nativeType=this.closest('k-filters')?.querySelector('input[name="filter.p.product_type"]')?.closest('fieldset');
      if(nativeType)nativeType.hidden=!this.fields[0].disabled;
    }
    static matchesRecipient(item,recipient){return !recipient||[recipient,'gavejas:'+recipient,'gavėjas:'+recipient].some(tag=>item.tags.includes(tag));}
    async apply(updateUrl=true) {
      this.request=(this.request||0)+1;const request=this.request;
      this.status.textContent=this.messages.loading;this.grid.setAttribute('aria-busy','true');
      try {
        const items=await this.catalogue();if(!this.isConnected||request!==this.request)return;
        this.populateExtraFilters();
        const type=this.fields[0].value,recipient=this.fields[1].value;
        this.toggleAttribute('data-k15-active',this.fields.some(field=>field.value));
        this.filtered=items.filter(item=>KukurGiftFilters.matchesType(item,type) && KukurGiftFilters.matchesRecipient(item,recipient) && this.fields.slice(2).every(field=>!field.value||item.tags.includes(field.value)));
        this.limit=35;this.page=updateUrl?1:Math.max(1,Number(new URL(location.href).searchParams.get('page'))||1);this.render();
        if(updateUrl){const url=new URL(location.href);for(const field of this.fields)field.value?url.searchParams.set(field.name,field.value):url.searchParams.delete(field.name);url.searchParams.delete('page');history.replaceState({},'',url);}
        document.querySelectorAll('[data-k15-quick]').forEach(link=>link.setAttribute('aria-current',(link.dataset.k15Field==='type'?type:recipient)===link.dataset.k15Value?'page':'false'));
        for(const form of document.querySelectorAll('.filter-form,[data-sort-form]'))for(const field of this.fields){let hidden=form.querySelector(`input[name="${field.name}"]`);if(!hidden){hidden=document.createElement('input');hidden.type='hidden';hidden.name=field.name;form.append(hidden);}hidden.value=field.value;}
      }catch(error){if(error.name!=='AbortError')this.status.textContent=this.messages.error;}
      finally{if(request===this.request)this.grid.removeAttribute('aria-busy');}
    }
    render(){
      const markup=this.filtered.slice(((this.page||1)-1)*this.limit,(this.page||1)*this.limit).map(item=>item.html).join('');
      const fragment=document.createRange().createContextualFragment(markup);
      this.grid.replaceChildren(fragment);
      const nativeEmpty=this.grid.parentElement.querySelector(':scope > .empty-state');if(nativeEmpty)nativeEmpty.hidden=true;
      this.status.textContent=this.messages.count+this.filtered.length;
      if(this.count)this.count.textContent=this.messages.count+this.filtered.length;
      this.more.hidden=true;
      const pageCount=Math.ceil(this.filtered.length/this.limit);
      this.pageNav ||= document.createElement('nav');
      this.pageNav.className='pagination catalogue-pagination';this.pageNav.setAttribute('aria-label','Puslapiai');
      this.results.append(this.pageNav);this.pageNav.replaceChildren();
      if(pageCount>1)for(const number of [...new Set([1,(this.page||1)-1,this.page||1,(this.page||1)+1,pageCount])].filter(n=>n>0&&n<=pageCount).sort((a,b)=>a-b)){
        const link=document.createElement('a');const url=new URL(location.href);url.searchParams.set('page',number);
        link.href=url.href;link.textContent=number;link.setAttribute('aria-label','Puslapis '+number);
        if(number===(this.page||1))link.setAttribute('aria-current','page');
        link.addEventListener('click',event=>{if(event.ctrlKey||event.metaKey||event.shiftKey)return;event.preventDefault();this.page=number;history.pushState({},'',url);this.render();this.grid.scrollIntoView({block:'start'});this.grid.querySelector('a')?.focus({preventScroll:true});});
        this.pageNav.append(link);
      }
      const empty=this.results.querySelector('[data-k15-empty]');empty.hidden=this.filtered.length>0;
      const pagination=document.querySelector('.collection-section .pagination');if(pagination&&!pagination.classList.contains('catalogue-pagination'))pagination.hidden=true;
    }
  }
  if(!customElements.get('k15-gift-filters')) customElements.define('k15-gift-filters',KukurGiftFilters);
  // Keep image 1 meaningful when task 11 supplies a model/lifestyle primary card image.
  for(const card of document.querySelectorAll('.product-card')) {
    const image=card.querySelector('.k15-card-frame img');
    if(image && /lifestyle|gyvenimo|modelis|modelio|žmog/iu.test(image.alt)){card.querySelector('.product-card__media').classList.remove('k-zoom');image.style.objectFit='cover';}
  }
})();
